// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 32px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.filter-title {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 16px 0;
}

.filter-controls {
    display: flex;
    gap: 16px;
    align-items: flex-end;
}

.filter-input-group {
    flex: 1 1;
    position: relative;
}

.filter-input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    color: #374151;
    background-color: white;
    outline: none;
    transition: all 0.2s ease;
    box-sizing: border-box;
}
/* Apply your existing filter-input styles to react-select */
.react-select__control {
    width: 100%;
    min-height: 44px; /* match DatePicker height, adjust if needed */
    padding: 0 16px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
    color: #374151;
    background-color: white;
    box-sizing: border-box;
    transition: all 0.2s ease;
}



.react-select__value-container {
    padding: 0;
    min-height: 44px;
}




.filter-input:focus {
    outline: 2px solid #3b82f6;
    outline-offset: -2px;
    border-color: transparent;
}

.filter-input:hover {
    border-color: #9ca3af;
}

.filter-input::placeholder {
    color: #9ca3af;
    font-size: 14px;
}

.filter-button {
    padding: 12px 32px;
    background-color: white;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    color: #374151;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 100px;
    height: fit-content;
}

.filter-button:hover {
    background-color: #f9fafb;
    border-color: #9ca3af;
}

.filter-button:focus {
    outline: 2px solid #3b82f6;
    outline-offset: -2px;
    border-color: transparent;
}

.filter-button:active {
    background-color: #f3f4f6;
}

/* DatePicker custom styles */
.react-datepicker-wrapper {
    width: 100%;
}

.react-datepicker__input-container {
    width: 100%;
}

.react-datepicker-popper {
    z-index: 1000;
}

.react-datepicker {
    font-family: inherit;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.react-datepicker__header {
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    border-radius: 8px 8px 0 0;
    padding: 8px 0;
}

.react-datepicker__current-month {
    color: #111827;
    font-weight: 600;
    font-size: 14px;
}

.react-datepicker__day-name {
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
}

.react-datepicker__day {
    color: #374151;
    font-size: 13px;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.react-datepicker__day:hover {
    background-color: #f3f4f6;
}

.react-datepicker__day--selected {
    background-color: #3b82f6;
    color: white;
}

.react-datepicker__day--selected:hover {
    background-color: #2563eb;
}

.react-datepicker__day--keyboard-selected {
    background-color: #dbeafe;
    color: #1d4ed8;
}

.react-datepicker__day--today {
    font-weight: 600;
    color: #3b82f6;
}

.react-datepicker__navigation {
    top: 12px;
}

.react-datepicker__navigation--previous {
    left: 12px;
}

.react-datepicker__navigation--next {
    right: 12px;
}

.react-datepicker__navigation-icon::before {
    border-color: #6b7280;
}

.react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
    border-color: #374151;
}

/* Clear button styling */
.react-datepicker__close-icon {
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    color: #9ca3af;
    font-size: 16px;
}

.react-datepicker__close-icon:hover {
    color: #6b7280;
}

/* Responsive design */
@media (max-width: 768px) {
    .filter-controls {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .filter-input-group {
        flex: none;
    }

    .filter-button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Filter.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2EAA2E;AAC/E;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B;AACA,4DAA4D;AAC5D;IACI,WAAW;IACX,gBAAgB,EAAE,8CAA8C;IAChE,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;AAC7B;;;;AAIA;IACI,UAAU;IACV,gBAAgB;AACpB;;;;;AAKA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,mFAAmF;AACvF;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".filter-container {\r\n    background: white;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 24px;\r\n    margin-bottom: 32px;\r\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.filter-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #111827;\r\n    margin: 0 0 16px 0;\r\n}\r\n\r\n.filter-controls {\r\n    display: flex;\r\n    gap: 16px;\r\n    align-items: flex-end;\r\n}\r\n\r\n.filter-input-group {\r\n    flex: 1;\r\n    position: relative;\r\n}\r\n\r\n.filter-input {\r\n    width: 100%;\r\n    padding: 12px 16px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    color: #374151;\r\n    background-color: white;\r\n    outline: none;\r\n    transition: all 0.2s ease;\r\n    box-sizing: border-box;\r\n}\r\n/* Apply your existing filter-input styles to react-select */\r\n.react-select__control {\r\n    width: 100%;\r\n    min-height: 44px; /* match DatePicker height, adjust if needed */\r\n    padding: 0 16px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    color: #374151;\r\n    background-color: white;\r\n    box-sizing: border-box;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n\r\n\r\n.react-select__value-container {\r\n    padding: 0;\r\n    min-height: 44px;\r\n}\r\n\r\n\r\n\r\n\r\n.filter-input:focus {\r\n    outline: 2px solid #3b82f6;\r\n    outline-offset: -2px;\r\n    border-color: transparent;\r\n}\r\n\r\n.filter-input:hover {\r\n    border-color: #9ca3af;\r\n}\r\n\r\n.filter-input::placeholder {\r\n    color: #9ca3af;\r\n    font-size: 14px;\r\n}\r\n\r\n.filter-button {\r\n    padding: 12px 32px;\r\n    background-color: white;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    color: #374151;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    min-width: 100px;\r\n    height: fit-content;\r\n}\r\n\r\n.filter-button:hover {\r\n    background-color: #f9fafb;\r\n    border-color: #9ca3af;\r\n}\r\n\r\n.filter-button:focus {\r\n    outline: 2px solid #3b82f6;\r\n    outline-offset: -2px;\r\n    border-color: transparent;\r\n}\r\n\r\n.filter-button:active {\r\n    background-color: #f3f4f6;\r\n}\r\n\r\n/* DatePicker custom styles */\r\n.react-datepicker-wrapper {\r\n    width: 100%;\r\n}\r\n\r\n.react-datepicker__input-container {\r\n    width: 100%;\r\n}\r\n\r\n.react-datepicker-popper {\r\n    z-index: 1000;\r\n}\r\n\r\n.react-datepicker {\r\n    font-family: inherit;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 8px;\r\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.react-datepicker__header {\r\n    background-color: #f9fafb;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    border-radius: 8px 8px 0 0;\r\n    padding: 8px 0;\r\n}\r\n\r\n.react-datepicker__current-month {\r\n    color: #111827;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n}\r\n\r\n.react-datepicker__day-name {\r\n    color: #6b7280;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n.react-datepicker__day {\r\n    color: #374151;\r\n    font-size: 13px;\r\n    border-radius: 4px;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.react-datepicker__day:hover {\r\n    background-color: #f3f4f6;\r\n}\r\n\r\n.react-datepicker__day--selected {\r\n    background-color: #3b82f6;\r\n    color: white;\r\n}\r\n\r\n.react-datepicker__day--selected:hover {\r\n    background-color: #2563eb;\r\n}\r\n\r\n.react-datepicker__day--keyboard-selected {\r\n    background-color: #dbeafe;\r\n    color: #1d4ed8;\r\n}\r\n\r\n.react-datepicker__day--today {\r\n    font-weight: 600;\r\n    color: #3b82f6;\r\n}\r\n\r\n.react-datepicker__navigation {\r\n    top: 12px;\r\n}\r\n\r\n.react-datepicker__navigation--previous {\r\n    left: 12px;\r\n}\r\n\r\n.react-datepicker__navigation--next {\r\n    right: 12px;\r\n}\r\n\r\n.react-datepicker__navigation-icon::before {\r\n    border-color: #6b7280;\r\n}\r\n\r\n.react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {\r\n    border-color: #374151;\r\n}\r\n\r\n/* Clear button styling */\r\n.react-datepicker__close-icon {\r\n    right: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background-color: transparent;\r\n    color: #9ca3af;\r\n    font-size: 16px;\r\n}\r\n\r\n.react-datepicker__close-icon:hover {\r\n    color: #6b7280;\r\n}\r\n\r\n/* Responsive design */\r\n@media (max-width: 768px) {\r\n    .filter-controls {\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n        gap: 12px;\r\n    }\r\n\r\n    .filter-input-group {\r\n        flex: none;\r\n    }\r\n\r\n    .filter-button {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
